module.exports = __webpack_public_path__ + "assets/img/yyCare_d_p3.4dd9123a.png";